// Single source of truth for the admin role gate.
//
// Confirmed against the live dev API on 2026-06-02: an admin account returns
// role `'ADMIN'` from login. The frontend check is for instant UX only; the
// backend remains authoritative (see isAuthFailureEnvelope + src/lib/axios.ts),
// so a wrong constant here could only ever be *too strict*, never permissive.
export const ADMIN_ROLE = 'ADMIN';
export function isAdminRole(role) {
    return role === ADMIN_ROLE;
}
// This backend returns HTTP 200 even when auth fails, signalling the failure in
// the response envelope: { success:false, errorCode:"AUTH...", ... } rather than
// via a 401/403 status. `isAuthFailureEnvelope` recognizes that shape so the
// axios interceptor can treat it like a 401 (clear session → /login).
export const AUTH_ERROR_PREFIX = 'AUTH';
export function isAuthFailureEnvelope(data) {
    if (!data || typeof data !== 'object')
        return false;
    const env = data;
    return (env.success === false &&
        typeof env.errorCode === 'string' &&
        env.errorCode.startsWith(AUTH_ERROR_PREFIX));
}
// Thrown when a successfully authenticated user is not an admin. Surfaced as the
// "You are not authorized" message on the login screen.
export class NotAuthorizedError extends Error {
    constructor(message = 'You are not authorized to access the admin portal.') {
        super(message);
        this.name = 'NotAuthorizedError';
    }
}
